import { stringify } from "qs";
import fetchClient from "api/client";
import getPerPageQueryParam from "helpers/getPerPageQueryParam";
import BRANDS_ENDPOINT from "./brandsEndpoint";

/**
 * @description GET api/brands/list
 * @param {Object} context - https://tanstack.com/query/v4/docs/react/guides/query-functions#queryfunctioncontext
 * @param {["brands", GetBrandsQueryParams]} context.queryKey
 * @param {AbortSignal} context.signal
 *
 * @return {Promise<GetBrandsResponse|Error>}
 * */
export default function getBrandsList({ queryKey: [, { page, perPage, ...queryParams }], signal }) {
  const queryString = stringify(
    {
      ...queryParams,
      page: page || 0,
      ...getPerPageQueryParam(perPage),
    },
    { addQueryPrefix: true },
  );

  return fetchClient.get(`${BRANDS_ENDPOINT}/list/${queryString}`, { signal });
}

/**
 * @typedef {Object} GetBrandsQueryParams
 * @property {number} [page]
 * @property {number} perPage
 * @property {string} [search]
 * */

/**
 * @typedef {Object} GetBrandsResponse
 * @property {Array<Brand>} data
 * @property {number} total
 * */

/**
 * @typedef {Object} Brand
 * @property {number | string} id
 * @property {string} name
 * */
